import { IFreeConsultancyRequest } from '../utils/entities/interface';
import { Pagination } from './booking';
import { get, post } from './https';

interface ConsultancyRequestsResponse {
  status: boolean;
  data: IFreeConsultancyRequest[];
  count: number;
  pagination: Pagination;
}

const GETConsultancyRequests = async ({
  page = 1,
  limit = 10,
  searchQuery = '',
  sortField = '',
  sortOrder = 'DESC',
}: {
  page?: number;
  limit?: number;
  searchQuery?: string;
  sortField?: string;
  sortOrder?: 'ASC' | 'DESC';
}): Promise<ConsultancyRequestsResponse> => {
  // Initialize the base URL
  let url = `/api/v1/admin/consultancy-list?limit=${limit}&page=${page}`;

  // Conditionally add search parameter if provided
  if (searchQuery) {
    url += `&search=${searchQuery}`;
  }

  // Conditionally add sortField and sortOrder if they are provided
  if (sortField && sortField !== 'name') {
    // assuming 'name' is the default field, you can change it if needed
    url += `&sortField=${sortField}`;
  }

  if (sortOrder && sortOrder !== 'ASC') {
    // assuming 'ASC' is the default sort order
    url += `&sortOrder=${sortOrder}`;
  }

  // Fetch the response
  const response = await get(url); // Use the previously defined `get` function

  if (response.status == 200) {
    return response.data; // If status is true, return the user data
  } else {
    throw new Error('Failed to fetch users');
  }
};

export { GETConsultancyRequests };
